import { formatToLocalTime, isToday } from './date-utils.js'; // Optional: extract these helpers

export function createFeedRow(feed, food, options = {}) {
  const {
    profileId,
    isHighlighted = false,
    onUndo = null
  } = options;

  const row = document.createElement('tr');
  row.classList.add('feed-row');

  const recordDate = new Date(feed.created_at + 'Z'); // Ensure UTC parsing
  const isYesterDay = !isToday(recordDate);

  if (isYesterDay) row.classList.add('yesterday-record');
  if (isHighlighted) row.classList.add('highlight-row');

  row.innerHTML = `
    <td>${food.name}</td>
    <td>${parseInt(food.weight * feed.amount, 10)}</td>
    <td data-original-date="${feed.created_at}">
      ${formatToLocalTime(feed.created_at)}
    </td>
    <td>${feed.nick || 'Unknown Client'}</td>
  `;

  // Handle undo functionality  
  if (isHighlighted && typeof onUndo === 'function') {
    row.classList.add('highlight-row');
    row.title = 'Click to undo'; // optional tooltip
  
    row.style.cursor = 'pointer'; // visually indicate interactivity
    row.addEventListener('click', () => {
      onUndo();
    }, { once: true }); // prevent double-undo
  }

  return {
    element: row,
    intake: food.weight * feed.amount
  };
}